import { useParams, useLocation } from "react-router";

import {
  PageContent,
  PageHeader,
  Section,
  Tabs,
  Tab,
  TabContent,
} from "components/layout";
import { RestrictedArea, ROLES } from "containers/Permissions";

import {
  PublicationsLegend,
  TiVoPublicationsEditTable,
  TiVoPublicationsHistoryTable,
  TiVoPublicationsSummaryTable,
  getPageMode,
  usePublicationsData,
} from ".";
import { MAIN_ROUTE } from "../constants";
import { PublicationsSearch } from "./components";
import { PATHS, TEXTS } from "./constants";
import { TargetsProvider } from "./TargetsProvider";
import styles from "./TiVoPublicationsList.scss";

export function TiVoPublicationsList() {
  const mode = getPageMode();
  const { tabId: platformId } = useParams();
  const { search } = useLocation();
  const { platforms, publications, status } = usePublicationsData();

  const renderHeader = () => {
    switch (mode) {
      case PATHS.EDIT:
        return TEXTS.HEADER.EDIT;
      case PATHS.HISTORY:
        return TEXTS.HEADER.HISTORY;
      default:
        return TEXTS.HEADER.SUMMARY;
    }
  };

  const renderTable = () => {
    switch (mode) {
      case PATHS.EDIT:
        return (
          <TiVoPublicationsEditTable
            platforms={platforms}
            publications={publications}
            status={status}
          />
        );
      case PATHS.HISTORY:
        return (
          <TiVoPublicationsHistoryTable
            platforms={platforms}
            publications={publications}
            status={status}
          />
        );
      default:
        return (
          <TiVoPublicationsSummaryTable
            platforms={platforms}
            publications={publications}
            status={status}
          />
        );
    }
  };

  return (
    <>
      <PageHeader>{renderHeader()}</PageHeader>
      <PageContent>
        <Section>
          <PublicationsSearch />
        </Section>
        <Section>
          <Tabs>
            <Tab
              active={mode === PATHS.SUMMARY}
              text={TEXTS.TAB_LABEL.SUMMARY}
              to={`/${MAIN_ROUTE}/publication/${PATHS.SUMMARY}/${platformId}${search || ""}`}
            />
            <RestrictedArea
              allowed={[ROLES.tivo.moderator]}
              showFallback={false}
            >
              <Tab
                active={mode === PATHS.EDIT}
                text={TEXTS.TAB_LABEL.EDIT}
                to={`/${MAIN_ROUTE}/publication/${PATHS.EDIT}/${platformId}${search || ""}`}
              />
            </RestrictedArea>
            <Tab
              active={mode === PATHS.HISTORY}
              text={TEXTS.TAB_LABEL.HISTORY}
              to={`/${MAIN_ROUTE}/publication/${PATHS.HISTORY}/${platformId}${search || ""}`}
            />
          </Tabs>
          <TargetsProvider>
            <TabContent>{renderTable()}</TabContent>
          </TargetsProvider>
        </Section>
        <PublicationsLegend className={styles.legend} />
      </PageContent>
    </>
  );
}
